import * as React from "react";
import { Button, Space } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { CardContent } from "../../../components/antd/card/CardContent";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpArrayString } from "../../gvc/testNewForm/CpArrayString";

interface Props {}
export const SecretDataECR: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();
  const isPasswordVisible = useCpFormValue(`ecr.secretKey.isVisible`);

  return (
    <>
      <CardContent>
        <div style={{ maxWidth: 600 }}>
          <CpFormItem>
            <CpLabel name={`ecr.accessKey`}>Access Key</CpLabel>
            <CpInput name={`ecr.accessKey`} />
            <CpErrorWarning name={`ecr.accessKey`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`ecr.secretKey.value`}>Secret Key</CpLabel>
            <Space.Compact>
              <CpInput name={`ecr.secretKey.value`} type={isPasswordVisible ? "text" : `password`} />
              <Button
                onClick={() => formSetValue(id, `ecr.secretKey.isVisible`, !isPasswordVisible)}
                icon={isPasswordVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              />
            </Space.Compact>
            <CpErrorWarning name={`ecr.secretKey.value`} />
          </CpFormItem>
          <CpArrayString label={`Repos`} name={`ecr.repos`} />
          <CpFormItem>
            <CpLabel name={`ecr.roleArn`}>Role ARN</CpLabel>
            <CpInput name={`ecr.roleArn`} />
            <CpErrorWarning name={`ecr.roleArn`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`ecr.externalId`}>External ID</CpLabel>
            <CpInput name={`ecr.externalId`} />
            <CpErrorWarning name={`ecr.externalId`} />
          </CpFormItem>
        </div>
      </CardContent>
    </>
  );
};
